import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import { Icon } from '@edx/paragon';

type ListItem = {
  iconSrc: ReactElement;
  text: string;
}

interface FooterListProps {
  list: ListItem[];
  variant?: string;
  className?: string;
}

function FooterList({ list, variant, className }: FooterListProps) {
  return (
    <ul className={classNames('list-style-none m-0 p-0 small', className)}>
      {list.map(({ iconSrc, text }) => (
        <li className="d-flex" key={`footer-list-${uuidv4()}`}>
          <Icon
            src={iconSrc}
            className={classNames(
              'mr-2.5',
              {
                'text-dark-500': variant === 'light',
                'text-light-200': variant === 'dark',
              },
            )}
          />
          <p>{text}</p>
        </li>
      ))}
    </ul>
  );
}

FooterList.defaultProps = {
  variant: 'light',
  className: '',
};

export default FooterList;
